import { ApiAddress } from '@/services/apis'
import { ID } from '@/services/common.model'
import request from '@/services/request'
import { Notification } from './notification.model'

export function getNotifications(): Promise<Notification.Info[]> {
  return request.get(ApiAddress.NOTIFICATIONS)
}

export function getNotificationCount(): Promise<number> {
  return request.get(ApiAddress.NOTIFICATIONS_COUNT)
}

export function notificationRead(ids: ID[]): Promise<number> {
  return request.put(ApiAddress.NOTIFICATIONS_READED, { ids })
}

export function notificationRemoves(ids: ID[]): Promise<number> {
  return request.put(ApiAddress.NOTIFICATIONS_REMOVES, { ids })
}
